import React from 'react'
import './card-holiday.css'

const CardHoliday = props => {
    const data = props.data
    
    return (
        <div className='card-holiday-container'>
            <div className='card-holiday-container-date'>
                <span>{data.day}</span>
            </div>

            <div className='card-holiday-container-legends'>
                <span className='card-holiday-type'>{data.description}</span>
                <span className='card-holiday-legend'>{data.dateFormat}</span>
            </div>

            <div className='card-holiday-container-missing'>
                <span>{data.remainingTime}</span>
            </div>
           
        </div>
    )
}

export default CardHoliday